<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">{{ title }}</h2>
        </div>
        <div class="modal-body">
            <LoadingWheel :width="100" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, SetupContext } from "vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
type Props = {
    title: string;
    loadingPromise: Promise<void>;
} & DialogProps;
export default defineComponent({
    props: ["title", "loadingPromise", "triggerElement"],
    setup(props: Props, context: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);

        props.loadingPromise.then(() => context.emit("close"));

        return {
            container: containerRef,
        };
    },
    components: {
        LoadingWheel,
    },
});
</script>
